






import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'

@Component
export default class ResourceUploadRule extends ViewBase {
  lang: any = {}

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  created() {
    this.lang = this.i18n.uploadRule
  }
}
